<template>
  <div class="pickup-tickets-container">
    <div class="pickup-tickets-wrapper">
      <header>SCREEN LOCK</header>
      <div class="text-center timerClock">
        {{ timestamp }}
      </div>
      <div class="pickup-tickets-center-content">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-3">
            <input v-model="password" id="lockpassword" ref="lockpassword" type="password" v-on:keyup.enter="onSubmit()" />
            <label>Enter Password to continue</label>
              <VkeyboardFloat
                :ID="'lockpassword'"
                :onClickFun="() => {
                  showVKeyboard = !showVKeyboard
                }"
              />
              <Vkeyboard
                :inputName="'lockpassword'"
                :showOrHide="showVKeyboard"
                :initialValue="password"
                @onChangeEvent="onChangeKeboardData('lockpassword')"
                @onKeyEnter="onKeyPress"
                @changeKeyboardInput="password = $event"
                @onClickClose="() => {
                  showVKeyboard = false;
                }"
              />
          </div>
          <div class="text-center mb-3 font-weight-normal fs-12">
            <!-- Screen locked by {{ userInfo }} -->
            LOCKED since
            {{ moment(LockedSince, "HH:mm:ss").format("HH:mm") }} by
            {{ userInfo }}. Locked for {{ LockedTimer(LockedSince) }}
          </div>
          <button class="btn-blue-lg" v-on:click="onSubmit()">Submit</button>
          <button class="btn-blue-lg ml-3" v-on:click="onLogout()">
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService.js";
import Vue from "vue";
import moment from "moment";
import { backendSocket } from "@/main.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  props: {
    onClickHandler: { type: Function }
  },
  components: {
    Vkeyboard,
    VkeyboardFloat,
  },
  beforeMount() {
    console.log("this.userInfo", this.userInfo);
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
    this.LockedSince = window.localStorage.getItem("LockedSinced")
      ? window.localStorage.getItem("LockedSinced")
      : moment().format("HH:mm:ss");
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function() {
      history.go(1);
    };
    this.interval = setInterval(() => {
      this.$forceUpdate();
    }, 1000);

    // // direct logout for now
    // this.onLogout()
  },
  destroyed: function() {
    clearInterval(this.interval);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.enableReload) {
      return;
    }
    next();
  },
  data() {
    return {
      // enterTicketDetails: true,
      // showTicketInfo: false,
      showVKeyboard: false,
      password: "",
      timestamp: "",
      interval: "",
      lockedTime: "",
      LockedSince: "",
      enableReload: false,
      hardware_id: "",
      DeviceUniqueCode: ""
    };
  },
  created() {
    setInterval(this.getNow, 1000);
    this.getNow();
  },
  methods: {
    onKeyPress(button) {
      console.log('ON ENTER', button);
      this.onSubmit()
    },
    onChangeKeboardData(refs) {
      if (refs) {
        console.log("Running onChnage", refs);
        this.$refs[refs].focus();
        this.$forceUpdate();
      }
    },
    moment,
    getNow: function() {
      this.timestamp = moment().format("HH:mm:ss");
    },
    LockedTimer(LockTime) {
      var startDate = new Date(moment(LockTime, "HH:mm:ss"));
      var endDate = new Date();
      var diff = endDate.getTime() - startDate.getTime();
      var hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * (1000 * 60 * 60);
      var minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * (1000 * 60);
      var seconds = Math.floor(diff / 1000);

      if (hours < 0) hours = hours + 24;

      return (
        (hours <= 9 ? "0" : "") +
        hours +
        " Hrs : " +
        (minutes <= 9 ? "0" : "") +
        minutes +
        " Min: " +
        (seconds <= 9 ? "0" : "") +
        seconds +
        " Sec"
      );
    },
    onLogout: async function() {
      window.localStorage.removeItem("LockedSinced");
      window.localStorage.removeItem("Locked");
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        if (backendSocket && backendSocket.connected) {
          backendSocket.emit("on_user_logout", {
            hardware_id: this.DeviceUniqueCode
          });
        }
      }
      window.localStorage.clear();
      this.enableReload = true;
      this.$cookie.delete("BRHSID");
      this.$router.push({
        path: "pos-login"
      });
    },
    onSubmit: function() {
      if (this.secureStore.get("DFLT_USINFO")) {
        let userRole = this.secureStore.get("DFLT_USINFO").role_id;
        let userInfo =
          this.secureStore.get("DFLT_USINFO") &&
          this.secureStore.get("DFLT_USINFO").username;
        if (this.password == "") {
          this.$toasted.show("Please Enter Password");
        } else {
          let payload = {
            username: userInfo,
            password: this.password
          };
          UserService.CheckUserPassword(payload)
            .then(response => {
              const { data } = response;
              console.log("data :", data, this);
              if (data.status) {
                // this.$router.go(-1);
                this.enableReload = true;
                window.localStorage.removeItem("LockedSinced");
                window.localStorage.removeItem("Locked");
                this.$store.dispatch("onSetAndSendLog", {
                  action: `User Unlocked the Screen`
                });
                console.log("data.status :", data.status, this.$router);
                // window.location.href = "/#/pos-booking";
                let accessLimitation = this.secureStore.get('BRUACS');
                if(accessLimitation) {
                  if(accessLimitation == 'SUPER' || accessLimitation == 'POSONLY') {
                    this.$router.push({
                    path: "/pos-booking"
                  });
                  } else if(accessLimitation == 'FNBONLY') {
                    this.$router.push({
                    path: "/pos-fnb"
                  });
                  } else {
                    this.onLogout();
                    this.$toasted.show('Please Login Again!')
                  }
                } else {
                  if (userRole == 8) {
                    this.$router.push({
                    path: "/pos-fnb"
                  });
                  } else {
                    this.$router.push({
                    path: "/pos-booking"
                  });
                  }
                }
                // this.$router.push({ path: "pos-booking" }).catch(e => {
                //   console.log("e :", e);
                // });
              } else {
                // window.localStorage.clear();
                // Vue.cookie.delete("BRHSID");
                // this.$router.push({
                //   path: "/pos-login"
                // });

                this.$toasted.show("Incorrect Password");
                // this.$router.push({
                //   path: "/pos-login"
                // });
              }
            })
            .catch(error => {
              // window.localStorage.clear();
              // Vue.cookie.delete("BRHSID");
              // this.$router.push({
              //   path: "/pos-login"
              // });
              console.log("error :", error);
            });
        }
      } else {
        console.log("No UserInfo Found");
      }
    }
  },
  computed: {
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name
        : "Admin";
    }
  }
};
</script>
<style>
.timerClock {
  /* position: absolute;
  right: 0;
  top: -77px;
  font-size: 20px;
  padding: 30px; */
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posLockScreen.vue